<script setup>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { useUserStore } from '@/stores/user'
const userStore = useUserStore();
import InlineSpinner from '@/components/InlineSpinner.vue';

const props = defineProps({
    percentValue: {
        type: Number,
        default: 0,
    },
    forecastValue: {
        type: Number,
        default: 0,
    },
    points: {
        type: Number,
        default: 0,
    },
    mode: {
        type: String,
        default: 'percentage',
    }
})

// Alle Props als Number behandeln, egal was ankommt
const percentValue = computed(() => props.percentValue);
const forecastValue = computed(() => props.forecastValue);
const points = computed(() => props.points);

const topValue = computed(() => {
    if (percentValue.value > 100) {
        return '0%';
    } else if (percentValue.value < -100) {
        return '200%';
    } else {
        return `${100 - percentValue.value}%`;
    }
});
const computedHeight = computed(() => {
    if (percentValue.value <= 100) {
        return '100%';
    } else {
        return `${200 - percentValue.value}%`;
    }
});

function changeBubbleColor(value) {
    if (value < 100) {
        return 'red';
    } else {
        return 'green';
    }
}
const bubbleColor = computed(() => changeBubbleColor(percentValue.value));

const textColor = computed(() => {
    if (percentValue.value < 55) {
        return '#000';
    }  else {
        return '#fff';
    }
});

const progressElements = ref([]);

// Optional: Animation-Code auskommentiert
// const intervalId = ref(null);
// function increasePercentValue() {
//     intervalId.value = setInterval(() => {
//         if (percentValue.value < 200) {
//             percentValue.value += 1;
//         } else {
//             percentValue.value = 0;
//         }
//     }, 100000);
// }
// onMounted(() => {
//     increasePercentValue();
// });
// onUnmounted(() => {
//     if (intervalId.value) {
//         clearInterval(intervalId.value);
//     }
// });
</script>

<template>
    <div class="circle-container positive">
        <div class="container cell-grid" v-if="userStore.currentSelection.activity.isLoading === true">
            <InlineSpinner size="sm" label="Lädt" />
        </div>
        <div class="circle-inner"></div>
        <div class="circle-inner-second"></div>
        <div class="circle-inner-third"></div>
        <div :class="bubbleColor" v-if="userStore.currentSelection.activity.isLoading !== true">
            <div class="progress">
                <div class="inner">
                    <div class="water" :style="{ top: topValue }"></div>
                    <div class="water" :style="{ top: topValue }"></div>
                    <div class="water" :style="{ top: topValue }"></div>
                    <div v-if="props.mode === 'points'" class="percent" :style="{ color: textColor }">
                        <span>{{ points === 0 ? '0.00' : points }}</span>
                    </div>
                    <div v-if="props.mode === 'percentage'" class="percent" :style="{ color: textColor }"><span>{{ percentValue }}</span>%</div>
                    <div class="glare"></div>
                </div>
            </div>
        </div>
        <div class="forecast-wrapper">
            <div class="circle-inner-fourth" :style="{ height: computedHeight }"></div>
        </div>
        <div class="circle-bg-container">
            <div class="circle-bg"></div>
            <div class="circle-bg"></div>
        </div>
        <div class="circle-border"></div>
    </div>
</template>

<!-- <style src="@/scss/bubbles.scss" scoped></style> -->